
export default function TrustBar() {
  return (
    <section className="bg-white py-10 sm:py-12 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 sm:gap-8 items-center justify-items-center">
          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-time-line text-[#F4B942] text-4xl"></i>
            </div>
            <div>
              <p className="text-[#1A2B4A] font-semibold text-base sm:text-lg whitespace-nowrap">Über 10 Jahre Erfahrung</p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-award-fill text-[#F4B942] text-4xl"></i>
            </div>
            <div>
              <p className="text-[#1A2B4A] font-semibold text-base sm:text-lg whitespace-nowrap">Zertifizierter Fachbetrieb</p>
            </div>
          </div>

          <div className="flex items-center space-x-4">
            <div className="w-12 h-12 flex items-center justify-center">
              <i className="ri-star-fill text-[#F4B942] text-4xl"></i>
            </div>
            <div>
              <p className="text-[#1A2B4A] font-semibold text-base sm:text-lg whitespace-nowrap">Höchste Qualitätsansprüche</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
